import { render, staticRenderFns } from "./magic.vue?vue&type=template&id=11b77936&lang=true&"
import script from "./magic.vue?vue&type=script&lang=js&"
export * from "./magic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports